import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

export function AuthExpirationListener() {
  const { logout } = useAuth();

  useEffect(() => {
    const handler = () => { logout(); };
    window.addEventListener('mi:session-expired', handler);
    return () => { window.removeEventListener('mi:session-expired', handler); };
  }, [logout]);

  return null;
}
